import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { parse as parseYaml } from "yaml";

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // No forzamos lng aquí, dejamos que LanguageDetector busque en
    // querystring → localStorage → cookie → y si no hay nada, fallbackLng
    supportedLngs: ["ca", "es", "en"],
    fallbackLng: "ca",  
    load: "languageOnly",
    nonExplicitSupportedLngs: true,    // Catalán por defecto
    debug: true,
    interpolation: { escapeValue: false },
    backend: {
      loadPath: "/locales/{{lng}}.yml",
      parse: data => parseYaml(data),
    },
    detection: {
      order: ["querystring", "localStorage", "cookie"],
      caches: ["localStorage", "cookie"],
    },
  });

export default i18n;
